import React, { useEffect } from 'react';
import useStyles from '../../../../style/js-style/containers/administration/personalization/personalizationStyle';
import { PALETTE_COLORS } from '../themeUtils';
import { useFormContext, useWatch } from 'react-hook-form';
import EAIcon from '../../../../components/common/EAIcon';

const PaletteInput = ({ inputItem, disabled }) => {
  const { classes } = useStyles();
  const [selectedPalette, setSelectedPalette] = React.useState(null);
  const formMethods = useFormContext();
  const {
    control,
    setValue,
  } = formMethods;
  const paletteColorName = useWatch({ control, name: `paletteColorName` });

  useEffect(() => {
    if (selectedPalette !== null){
      setValue('colorPrimary', PALETTE_COLORS[selectedPalette][900])
      setValue('colorHover', PALETTE_COLORS[selectedPalette][500])
      setValue('colorBackground', PALETTE_COLORS[selectedPalette][50])
      setValue('paletteColorName', PALETTE_COLORS[selectedPalette].name)
    }
  }, [selectedPalette, setValue]);

  return (
    <div className={classes.paletteContainer} style={{opacity: disabled ? .7:1}}>
      {PALETTE_COLORS.map((color, index) => (
        <div
          className={paletteColorName === color.name ? classes.selectedPalette : classes.unselectedPalette}
          key={index}
          onClick={() => !disabled && setSelectedPalette(index)}
        >
          <div className={classes.inputPaletteItemWrapper} style={{ border: "1px solid " + color['900'] }} >
            <div className={classes.inputPaletteItemColorPart} style={{ backgroundColor: color['900'] }} />
            <div className={classes.inputPaletteItemColorPart} style={{ backgroundColor: color['500'] }} >
              {paletteColorName === color.name &&
                <EAIcon icon={"personalization/check_circle"} />
              }
            </div>
            <div className={classes.inputPaletteItemColorPart} style={{ backgroundColor: color['50'] }} />
          </div>
        </div>
      ))}
    </div>
  );
}

export default PaletteInput;